/**
 * Center-crops and resizes an image File/Blob to exact pixel dimensions using the browser Canvas API.
 * Scales to cover the target area (no distortion), then crops from the center.
 * Returns a Promise that resolves to a Blob (JPEG, quality 0.92).
 */
export const cropAndResizePhoto = (file, targetW = 105, targetH = 119) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(url);
      const scale = Math.max(targetW / img.width, targetH / img.height);
      const scaledW = img.width * scale;
      const scaledH = img.height * scale;
      const canvas = document.createElement('canvas');
      canvas.width = targetW;
      canvas.height = targetH;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(
        img,
        -(scaledW - targetW) / 2,
        -(scaledH - targetH) / 2,
        scaledW,
        scaledH
      );
      canvas.toBlob(
        (blob) => {
          if (blob) resolve(blob);
          else reject(new Error('Canvas toBlob failed'));
        },
        'image/jpeg',
        0.92
      );
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Failed to load image'));
    };

    img.src = url;
  });
